import React from "react";
import hero from "../assets/hero.jpg";

const Achievement = () => {
  return (
    <section className="py-5 achievement-section">
      <div className="container-fluid">

        {/* Section Title */}
        <div className="text-center mb-5">
            <h6 className="text-uppercase text-primary fw-bold mb-3">
                OUR ACHIEVEMENT
            </h6>

          <h1 className="fw-bold display-5 section-title raleway">
            Driving Financial Empowerment for<br /> Women Across India
          </h1>
        </div>

        {/* Content Row */}
        <div className="row g-4">

          {/* Left Image Card */}
          <div className="col-lg-3 col-md-6">
            <div className="achievement-image-card shadow-sm rounded-4 overflow-hidden">
              <img
                src={hero}
                alt="Happy family"
                className="img-fluid w-100 h-100 object-fit-cover"
              />
            </div>
          </div>

          {/* Stat Card 1 */}
          <div className="col-lg-3 col-md-6">
            <div className="achievement-card p-4 rounded-4 shadow-sm bg-white h-100">
              <h5 className="fw-bold mb-2">Total Clients</h5>
              <p className="text-muted mb-4">
                Proudly serving women across India with tailored financial solutions and reliable support.
              </p>
              <h2 className="fw-bold text-primary">12.5K+</h2>
            </div>
          </div>

          {/* Stat Card 2 */}
          <div className="col-lg-3 col-md-6">
            <div className="achievement-card p-4 rounded-4 shadow-sm bg-white h-100">
              <h5 className="fw-bold mb-2">Loan Approvals</h5>
              <p className="text-muted mb-4">
                Helping women achieve their goals with quick and seamless loan approvals. 
              </p>
              <h2 className="fw-bold text-primary">8.9K+</h2>
            </div>
          </div>

          {/* Stat Card 3 */}
          <div className="col-lg-3 col-md-6">
            <div className="achievement-card p-4 rounded-4 shadow-sm bg-white h-100">
              <h5 className="fw-bold mb-2">Trusted Partners</h5>
              <p className="text-muted mb-4">
                Collaborating with leading institutions to provide secure and reliable financial solutions.
              </p>
              <h2 className="fw-bold text-primary">25+</h2>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Achievement;
